
export default {
    Reservation: 1,
    Guest: 3,
    Addon: 11,
    RoomType: 12,
    Customer: 15,
    AGENT: 20,
    COMPANY: 21,
    Package: 28,
    ReservationGroup:29,
    ApartmentOwner: 30,
    CustomerGroup: 47,
    Folio: 53,
    Rate: 76,
    Promotion: 100
};